// sZtLeafType说明
export var LeafType = {
  Focus: 'type_183',
  // 焦点图
  Placeholder: 'type_35',
  // 占位符
  //    sCType:占位符类型
  //        extend_marquee 跑马灯
  //        extend_exclusive_gift 专属礼物
  //        extend_modtype 书签
  //          type_195:竖图组合
  //          type_196:方图组合
  //          type_194：横图组合
  VipDiscounts: 'type_192',
  // 开通优惠vip
  Discounts: 'type_191',
  // 开通优惠非vip
  OfflineAct: 'type_190',
  // 线下活动
  SecondKill: 'type_189',
  // 限时秒杀
  LevelWelfare: 'type_188',
  // 等级福利
  BelongsWelfare: 'type_187',
  // 专属福利
  NormalMod: 'type_186',
  // 普通活动
  QuickEntry: 'type_185',
  // 福利社小入口
  GiftMod: 'type_246' // 专属礼包
};

export var NormalModVisible = {
  All: 0,
  HVip: 1,
  SVip: 2
};